import { TopolGifBlock } from "@/schemas/template/blocks/gifBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolGifBlock {
    const gifDefaults = state.mjml.attributes["mj-gif"] || {};
    return {
      uid: uuidv4(),
      tagName: "mj-gif",
      attributes: {
        src: "https://media3.giphy.com/media/ZeeUrTADWgFUc/giphy.gif",
        padding: gifDefaults["padding"] || "0px",
        "fluid-on-mobile": gifDefaults["fluid-on-mobile"] || "false",
        alt: "",
        href: "",
        ...(gifDefaults["border-radius"] && {
          "border-radius": gifDefaults["border-radius"],
        }),
        ...(gifDefaults["align"] && { align: gifDefaults["align"] }),
        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },
    };
  },
};
